import React from 'react'

/**
 * Performs an LTI redirect via POST form or GET link.
 * The redirect happens upon `props.route_action` being set.
 */
export function LtiRedirect({
  route_method="POST",    // GET uses <a> / POST uses <form>
  route_action=null,      // link url / form action
  route_data=null,        // query params / form input values
}) {
  const actionRef = React.useRef()
  React.useEffect(() => {
    if (route_action) {
      if (route_method === 'GET') {
        actionRef.current.click()
      }else{
        actionRef.current.submit()
      }
    }
  }, [route_action])

  if (route_method === 'GET') {
    return (
      <a
        href={route_action}
        className="d-none"
      >
        Continue
      </a>
    )


  }else{ // POST
    return (
      <form
        ref={actionRef}
        method="POST"
        action={route_action}
        encType="application/x-www-form-urlencoded"
      >
        {route_action && route_data && Object.entries(route_data).map(([name, value]) => (
          <input
            key={name}
            type="hidden"
            name={name}
            value={value}
          />
        ))}
        {route_action &&
          <input
            type="submit"
            value="Continue"
            className="d-none"
          />
        }
      </form>
    )
  }
}

